import { reqArray, reqNumber, reqRecord } from '../value-objects/parse-helpers';

/// ページング wrapper。ページングは API/UI 寄りの汎用構造なので domain ではなく shared に置く。
/// generic な `Paged<T>` のみを参照し domain 非依存 (FSD: shared は domain を import しない)。
/// 各エンティティの旧 `PagedFirms` 等は `Paged<Firm>` 等に置換する (#471)。
export interface Paged<T> {
  items: T[];
  total: number;
  page: number;
  page_size: number;
}

/// `unknown` のページングレスポンスを構造ガードし、items を item parser で写す。
/// item parser には domain の `parseFirm` 等を注入する (parse, don't validate)。
export function parsePaged<T>(raw: unknown, parseItem: (item: unknown) => T): Paged<T> {
  const o = reqRecord(raw, 'paged');
  return {
    items: reqArray(o.items, 'paged.items').map(parseItem),
    total: reqNumber(o.total, 'paged.total'),
    page: reqNumber(o.page, 'paged.page'),
    page_size: reqNumber(o.page_size, 'paged.page_size'),
  };
}
